import actionTypes from './action-types';
import { normalize } from './helpers';

export default (state = {}, action) => {
    const requestSearchResults = () => {
        return {
            ...state,
            isFetching: true,
            error: null
        };
    };

    const receiveSearchResults = () => {
        const {
            payload: { result = {}, queryParams = null }
        } = action;
        return {
            ...state,
            isFetching: false,
            error: null,
            queryParams,
            ...normalize(result)
        };
    };

    const handleSearchResultsError = () => {
        return {
            ...state,
            isFetching: false,
            error: action.payload
        };
    };

    const updateRouting = () => {
        const { payload } = action;
        return {
            ...state,
            routing: {
                ...payload
            }
        };
    };

    const setSingleFilter = () => ({
        ...state,
        filters: {
            ...state.filters,
            [action.payload.filter]: {
                ...state.filters[action.payload.filter],
                selectedValue: action.payload.value
            }
        }
    });

    const setCategoryFilter = () => ({
        ...state,
        activeCategory: action.payload
    });

    const addItemOnDisplay = () => {
        const { payload } = action;
        return {
            ...state,
            itemsOnDisplayById: state.itemsOnDisplayById.includes(
                payload.itemId
            )
                ? [...state.itemsOnDisplayById]
                : [...state.itemsOnDisplayById, payload.itemId]
        };
    };

    const removeItemOnDisplay = () => {
        const { payload } = action;
        const items = state.itemsOnDisplayById.filter(
            item => item !== payload.itemId
        );
        return {
            ...state,
            itemsOnDisplayById: [...items]
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.REQUEST_SEARCH_RESULTS]: requestSearchResults,
        [actionTypes.RECEIVE_SEARCH_RESULTS]: receiveSearchResults,
        [actionTypes.HANDLE_SEARCH_RESULTS_ERROR]: handleSearchResultsError,
        [actionTypes.UPDATE_ROUTING]: updateRouting,
        [actionTypes.SET_SINGLE_FILTER]: setSingleFilter,
        [actionTypes.SET_ACTIVE_CATEGORY]: setCategoryFilter,
        [actionTypes.ADD_ITEM_ON_DISPLAY]: addItemOnDisplay,
        [actionTypes.REMOVE_ITEM_ON_DISPLAY]: removeItemOnDisplay
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
